<div class="ds-dialog">
  <div class="ds-header-dialog">
    <h3>{{ 'SELECT_TEAM' | translate }}</h3>
    <mat-icon (click)="close()" svgIcon="close-l"></mat-icon>
  </div>

  <form>
    <div class="content">
      <mat-form-field class="border-radius-12 attendance" appearance="outline">
        <mat-label>{{ 'SELECT_TEAM' | translate }}</mat-label>
        <app-input-select-search [items]="teamsSelect" [formControl]="teamControl"> </app-input-select-search>
        <mat-icon
          matSuffix
          (click)="teamControl?.setValue(undefined); $event.stopPropagation()"
          class="field_search_select__icon"
          >close</mat-icon
        >
      </mat-form-field>
    </div>

    <div class="confirm__buttons">
      <div class="p-16 ds-shadow-top d-flex ds-action-buttom">
        <button
          (click)="close()"
          mat-button
          class="widgetform__cancel ds-bottom ds-bottom-danger"
          [style.color]="'white'"
        >
          {{ 'CANCEL' | translate }}
        </button>
        <button
          [disabled]="!!!teamControl.value"
          (click)="save()"
          mat-raised-button
          class="widgetform__confirm ds-bottom ds-bottom-primary ds-bottom-with-loading ml-16"
          color="primary"
        >
          {{ 'CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
